import { useEffect, useState } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import Loader from "../../component/Loader/Loader";

// Legacy plan codes still sent by older desktop builds.
const PLAN_CODES = {
  aJ3d8Lk29vX4: "Pro", // Monthly
  N9sJ0qWz7eB1: "Pro_Annual", // Annual
};

/**
 * /checkout/:planId/:clientSecret  (legacy)
 *
 * Older desktop builds still open a URL that carries the Stripe client secret.
 * This bridge posts that secret to the backend (request body, not a URL), gets
 * a checkout token back, and replaces the URL with /checkout/:token so the
 * secret leaves the address bar and browser history immediately. Delete this
 * route once every client opens the `checkoutUrl` the backend returns.
 */
const LegacyCheckoutRedirect = () => {
  const { planId, clientSecret } = useParams();
  const navigate = useNavigate();
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let cancelled = false;

    const exchange = async () => {
      try {
        const url = `${process.env.REACT_APP_BACKEND_URL}api/stripe/checkout-session/from-secret`;
        const res = await fetch(url, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({
            clientSecret,
            plan: PLAN_CODES[planId] || "Pro",
          }),
        });

        let payload = null;
        try {
          payload = await res.json();
        } catch {
          // ignore non-json
        }
        if (cancelled) return;

        if (!res.ok || !payload?.success || !payload?.checkoutToken) {
          setFailed(true);
          return;
        }

        navigate(`/checkout/${payload.checkoutToken}`, { replace: true });
      } catch {
        if (!cancelled) setFailed(true);
      }
    };

    exchange();
    return () => {
      cancelled = true;
    };
  }, [planId, clientSecret, navigate]);

  if (failed) {
    return (
      <div className="min-h-[60vh] flex flex-col items-center justify-center gap-4 p-6 text-center font-inter">
        <p className="text-xl font-medium text-[#1A1A1AE5]">
          Checkout link expired
        </p>
        <p className="max-w-md text-[#1A1A1A99]">
          This checkout link is no longer valid. Please choose your plan again.
        </p>
        <Link
          to="/pricing"
          className="mt-2 rounded-full bg-gradient-to-r from-[#3AB1F6] to-[#407BFF] px-6 py-2.5 font-semibold text-white"
        >
          Back to pricing
        </Link>
      </div>
    );
  }

  return <Loader />;
};

export default LegacyCheckoutRedirect;
